<template>
  <div>
    <gallery :width="600" :height="400" responsive :items="images"/>
  </div>
</template>
 
<script>
    import Lingallery from 'lingallery';

    export default {
        props: ['images'],
        components: {
            'gallery': Lingallery
        },
    }
</script> 
 
<style scoped>
    .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }
</style> 
